import React from "react";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import Layout from "Layout";
import Button from "@material-ui/core/Button";
import PersonAdd from "@material-ui/icons/PersonAdd";
import PersonIcon from "@material-ui/icons/Person";
import GTranslate from "@material-ui/icons/GTranslate";
import Assignment from "@material-ui/icons/Assignment";
import GroupAdd from "@material-ui/icons/GroupAdd";
import AssignmentReturned from "@material-ui/icons/AssignmentReturned";
import { Link } from "react-router-dom";
import useAuth from "Hooks/useAuth";
import googleAnalytics from "fuction/googleAnalytics";

const useStyles = makeStyles(() => ({
  menueText: {
    fontSize: "16px",
  },
}));

export default function Setting(props) {
  const { state } = useAuth();
  const classes = useStyles();

  React.useEffect(() => {
    // タイトル変更
    document.title = "Buzz Finder - 設定";
  }, []);

  React.useEffect(() => {
    googleAnalytics(props.location.pathname, state.user.account_id);
  }, [props.location.pathname]);

  return (
    <Layout
      content={
        <Grid className={classes.menueText}>
          {state.user.admin && (
            <>
              <Grid item>
                <Link to="/config/contract">
                  <Button  className={classes.menueText} startIcon={<Assignment />} href="/config/contract">
                    ご契約内容
                  </Button>
                </Link>
              </Grid>
              <Grid item>
                <Link to="/config/user">
                  <Button  className={classes.menueText} startIcon={<PersonAdd />} href="/config/user">
                    ユーザアカウント管理
                  </Button>
                </Link>
              </Grid>
              <Grid item>
                <Link to="/config/keyword">
                  <Button  className={classes.menueText} startIcon={<GTranslate />} href="/config/keyword">
                    取得キーワード管理
                  </Button>
                </Link>
              </Grid>
              <Grid item>
                <Link to="/config/dtm">
                  <Button  className={classes.menueText} startIcon={<GroupAdd />} href="/config/dtm">
                    デイリートピックメール送付先管理
                  </Button>
                </Link>
              </Grid>
              {/* Add 2023.03.31 投稿分類 */}
              {state.user.options?.analysis && (
                <>
                  <Grid item>
                    <Link to="/config/dictionarysetting/menu">
                      <Button  className={classes.menueText} startIcon={<AssignmentReturned />} href="/config/dictionarysetting/menu">
                        投稿分類管理
                      </Button>
                    </Link>
                  </Grid>
                </>
              )}
            </>
          )}
          <Grid item>
            <Link to="/config/password">
              <Button  className={classes.menueText} startIcon={<PersonIcon />} href="/config/password">
                パスワード変更
              </Button>
            </Link>
          </Grid>
        </Grid>
      }
    />
  );
}
